import axios from 'axios'
import {to} from './utils'

export default {
  async createOrder (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/order`, body))
  },
  async getOrders (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/orders`, body))
  },
  async getOrder (orderId) {
    return to(axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/order/details/${orderId}`))
  },
  async changeStatusOrder (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/change_order_status`, body))
  },
  async createServicesOrder (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/order/services`, body))
  }, 
  async getStripeClientSecretId (body) {
    return to(axios.post(`${process.env.VUE_APP_API_ENDPOINT}/api/v1.0/secret`, body))
  },    
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/endpoints/order.js
// module id = null
// module chunks = 